import classNames from 'classnames';
import { LogoTheme, Size } from '../../../../constants';
import { useDots } from '../../../../hooks/useDots';
import { m } from 'framer-motion';
import { Logo } from '../../../navbar/Logo';
import { ThemePrimary } from '../../../../context/theme/ThemeConstantsUpdated';

const { primaryText } = ThemePrimary;

export const LoaderLogo = (props: Props) => {
  const { excludeFade, mainline, tagline, isMobile, forceLightStyle, excludeDots, forceMobile } = props;

  const dotClass = useDots(true);

  return (
    <m.div
      className={classNames(
        forceMobile ? 'flex' : isMobile ? 'flex md:hidden' : 'hidden md:flex',
        'max-w-full flex-col items-center justify-center px-5'
      )}
      initial={{
        opacity: excludeFade ? 1 : 0,
        scale: isMobile || forceMobile ? 0.25 : 0.6,
      }}
      animate={{
        opacity: 1,
        scale: isMobile || forceMobile ? 0.5 : 1,
      }}
      transition={{ duration: 1 }}
    >
      <Logo
        size={Size.xl}
        theme={forceLightStyle ? LogoTheme.light : LogoTheme.primary}
        textColorOverride={forceLightStyle ? 'text-gray-700' : 'text-white'}
        options={{ excludeLink: true }}
      />
      <div className="relative -top-7 mb-3 flex items-center">
        <h1
          className={classNames(
            forceLightStyle ? 'text-white' : primaryText,
            !excludeDots && dotClass,
            'text-8xl font-bold tracking-tighter'
          )}
        >
          {mainline}
        </h1>
      </div>

      <div className={classNames(forceLightStyle ? 'text-white' : primaryText, 'relative -top-7 text-3xl font-bold')}>
        {tagline}
      </div>
    </m.div>
  );
};

type Props = {
  excludeFade?: boolean;
  excludeDots?: boolean;
  mainline?: string;
  tagline?: string;
  isMobile?: boolean;
  forceMobile?: boolean;
  forceLightStyle?: boolean;
};
